import 'core-js/stable';
import 'regenerator-runtime/runtime';
import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import objectFitImages from 'object-fit-images';
// import objectFitVideos from 'object-fit-videos';
import AOS from 'aos';

svg4everybody();
objectFitImages();
// objectFitVideos();

window.$ = $;
window.jQuery = $;
window.objectFitImages = objectFitImages;
// window.objectFitVideos = objectFitVideos;
window.gsap = gsap;
window.AOS = AOS;
window.ScrollToPlugin = ScrollToPlugin;
require('ninelines-ua-parser');
/* eslint-disable */
// eslint-disable-next-line no-empty
document.getElementById('video-main').onplay = function () {
	AOS.init();
};

document.getElementById('video-main-mobile').onplay = function () {
	AOS.init();
};
/* eslint-enable */
